<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'paymentEdit',
    components: {
      baseEdit,
    },
  };
</script>
